import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { CardContainer } from '@taleemabad/dsm/components';

interface AuthCardInterface {
  children: ReactNode;
  className?: string;
}

export const AuthContainer = ({ children, className }: AuthCardInterface) => {
  return (
    <CardContainer
      role="form"
      variant="outline"
      className={className}
      emotionCss={css`
        display: flex;
        flex-direction: column;
        padding: var(--rk-spacing-xxxxl) var(--rk-spacing-xxxl)
          var(--rk-spacing-xxxxl) var(--rk-spacing-xxxl);
        width: 497px;
        ${mq(BreakpointSizes.xs)} {
          padding: 16px;
          width: calc(100% - var(--rk-spacing-xxxl));
          border: none;
          background-color: inherit;
        }
      `}
    >
      {children}
    </CardContainer>
  );
};
